import { fetchData } from '../utils';

const IPADDRESS = async () => {
  return (
    fetchData({
      url: '/api/embed/ip/',
      method: 'GET',
    }) ?? null
  );
};

export default IPADDRESS;
